module.exports = __webpack_public_path__ + "static/media/ALevel_subject_choice.3e993651.png";